export default "__VITE_ASSET__e507634e__"